
function increaseCount(a, b) {

    var qtySelector = b.getAttribute('dataqtytarget');
    var input = b.previousElementSibling;
    var value = parseInt(input.value, 10); 
    value = isNaN(value)? 0 : value;
    value ++;
    input.value = value;
    document.querySelector('#'+qtySelector).value = value;

}
function decreaseCount(a, b) {    
    var qtySelector = b.getAttribute('dataqtytarget');
    var input = b.nextElementSibling;
    var value = parseInt(input.value, 10); 
    if (value > 1) {
      value = isNaN(value)? 0 : value;
      value --;
      input.value = value;
      document.querySelector('#'+qtySelector).value = value;
    }
}
  
function myFunction(a, b) {

    var qtySelector = b.getAttribute('dataqtytarget');
    let input_value = b.value;
    document.querySelector('#'+qtySelector).value = input_value;

}

// ======================work by heseven==================
// header drawer close when click of any menu item in mobile drawer
const menuDrawer = document.querySelector('#menu-drawer');
const menuIcon = document.querySelector('#Details-menu-drawer-container .header__icon--menu');
if (menuDrawer && menuIcon) {
  menuDrawer.addEventListener('click', () => {
    menuIcon.click();
  });
} else {
  console.warn('Required elements are not found in the DOM.');
}

// splide slidr initialization 
class CustomSplide extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    // Initialize Splide when the element is added to the DOM
    this.initSplide();
  }

  initSplide() {
    const splide = new Splide('.splide');
    splide.mount();
  }
}
customElements.define('custom-splide', CustomSplide);

// custom accordion code 
let accordian = document.querySelectorAll('.accordian');
accordian.length && accordian.forEach((element)=>{
    let icon = element.querySelector('.custom-icon-arrow');
    let answer = element.querySelector('.answer');
    element.addEventListener('click',()=>{
        // icon.classList.toggle('open');
        // answer.classList.toggle('open');
        if (icon.classList.contains('open')){
            icon.classList.remove('open');
            answer.style.maxHeight = null;
        }else{
            icon.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
        }
    })
})

// readmore readless javascript
document.addEventListener("DOMContentLoaded", function() {
  const toggleContainers = document.querySelectorAll('[data-toggle]');

    toggleContainers.length && toggleContainers.forEach(container => {
    const toggleButton = container.querySelector('.readmore__toggle');
    const moreText = container.querySelector('.readmore__more');

    toggleButton.addEventListener('click', function() {
      if (moreText.style.display === "none") {
        moreText.style.display = "inline";
        toggleButton.textContent = "Read Less";
      } else {
        moreText.style.display = "none";
        toggleButton.textContent = "Read More";
      }
    });
  });
});



// //// prdocut card info popup in mobile 
// class PDPCard extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     this.openBtn = this.querySelector(".card__pop-up-open");
//     if (!this.openBtn ) return;

//     this.init();
//   }

//   isMobile() {
//     return window.innerWidth < 750;
//   }

//   init(){
//     const popup = document.getElementById("mobile-card-popup");
//     if (!popup) return;

//     const popupContent = popup.querySelector(".popup-content");
//     const overlay = popup.querySelector(".popup-overlay");

//     document.querySelectorAll(".card-wrapper").forEach(card => {

//       const openBtn = card.querySelector(".card__pop-up-open");
//       const content = card.querySelectorAll(".card__content")[1];

//       if (!openBtn || !content) return;

//       openBtn.addEventListener("click", () => {

//         const clone = content.cloneNode(true);

//         popupContent.innerHTML = "";
//         popupContent.appendChild(clone);

//         popup.classList.add("active");
//         document.body.style.overflow = "hidden";
//       });
//     });
//     overlay.addEventListener("click", () => {
//       popup.classList.remove("active");
//       document.body.style.overflow = "";
//       popupContent.innerHTML = "";
//     });
//   }
// }

// customElements.define("pdp-card", PDPCard);


// prdocut card info popup in mobile 
// class PDPCard extends HTMLElement {
//   constructor() {
//     super();

//     this.popup = document.getElementById("mobile-card-popup");
//     if (!this.popup) return;

//     this.popupContent = this.popup.querySelector(".product-card-popup-mobile");
//     this.overlay = this.popup.querySelector(".popup-overlay");

//     this.handleOpen = this.handleOpen.bind(this);
//     this.handleClose = this.handleClose.bind(this);
//   }

//   connectedCallback() {
//     this.openBtn = this.querySelector(".card__pop-up-open");
//     this.content = this.querySelectorAll(".card__content")[1];

//     if (!this.openBtn || !this.content) return;

//     this.openBtn.addEventListener("click", this.handleOpen);

//     // overlay (attach only once globally)
//     if (!this.popup.dataset.listenerAdded) {
//       this.overlay.addEventListener("click", this.handleClose);

//       document.addEventListener("keydown", (e) => {
//         if (e.key === "Escape") this.handleClose();
//       });

//       this.popup.dataset.listenerAdded = "true";
//     }
//   }

//   isMobile() {
//     return window.innerWidth < 750;
//   }

//   handleOpen() {
//     if (!this.isMobile()) return;

//     const clone = this.content.cloneNode(true);

//     this.popupContent.innerHTML = `
//       <button class="popup-close-btn">✕</button>
//     `;

//     this.popupContent.appendChild(clone);

//     this.popup.classList.add("active");
//     document.body.style.overflow = "hidden";

//     // close btn
//     this.popupContent
//       .querySelector(".popup-close-btn")
//       .addEventListener("click", this.handleClose);
//   }

//   handleClose() {
//     this.popup.classList.remove("active");
//     document.body.style.overflow = "";
//     this.popupContent.innerHTML = "";
//   }
// }

// customElements.define("pdp-card", PDPCard);


// //// prdocut card info popup in mobile 
class PDPCard extends HTMLElement {
  constructor() {
    super();

    this.popup = document.getElementById("mobile-card-popup");
    if (!this.popup) return;

    this.popupContent = this.popup.querySelector(".popup-content");
    this.overlay = this.popup.querySelector(".popup-overlay");

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.originalParent = null;
    this.originalNextSibling = null;
  }

  connectedCallback() {
    this.openBtn = this.querySelector(".card__pop-up-open");
    this.content = this.querySelectorAll(".card__content")[1];

    if (!this.openBtn || !this.content) return;

    this.openBtn.addEventListener("click", this.handleOpen);

    // attach global listeners once
    if (!this.popup.dataset.listenerAdded) {
      this.overlay.addEventListener("click", this.handleClose);

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.handleClose();
      });

      this.popup.dataset.listenerAdded = "true";
    }
  }

  isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  handleOpen() {
    if (!this.isMobile()) return;

    // save original position
    this.originalParent = this.content.parentNode;
    this.originalNextSibling = this.content.nextSibling;

    // move element (NOT clone)
    this.popupContent.innerHTML = `
      <button class="popup-close-btn">✕</button>
    `;
    this.popupContent.appendChild(this.content);

    this.popup.classList.add("active");
    document.body.style.overflow = "hidden";

    // close button
    this.popupContent
      .querySelector(".popup-close-btn")
      .addEventListener("click", this.handleClose);
  }

  handleClose() {
    if (!this.content || !this.originalParent) return;

    // move back to original place
    if (this.originalNextSibling) {
      this.originalParent.insertBefore(this.content, this.originalNextSibling);
    } else {
      this.originalParent.appendChild(this.content);
    }

    this.popup.classList.remove("active");
    document.body.style.overflow = "";
    this.popupContent.innerHTML = "";
  }
}

customElements.define("pdp-card", PDPCard);

